import React from 'react';
import { CardContent, Typography, Button } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

import { useTranslation } from '../../context/TranslationContext';
import { StyledUserCard, StyledUserCardAvatar } from '../../constants/styledComponents';

const UserCard = ({ title, subtitle, text, children, onSignOut, ...restProps }) => {
  const { translate } = useTranslation();

  return (
    <StyledUserCard {...restProps}>
      <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <StyledUserCardAvatar />
        <Typography
          color="textPrimary"
          sx={{
            marginTop: '5px',
          }}
        >
          {title}
        </Typography>
        <Typography>{subtitle}</Typography>
        <Button
          style={{ marginTop: 5, fontSize: 12 }}
          variant="contained"
          color="primary"
          endIcon={<ExitToAppIcon />}
          onClick={onSignOut}
        >
          {translate('header.SignOut')}
        </Button>
        <Typography variant="body2">
          <small>{text}</small>
        </Typography>
      </CardContent>
      {children}
    </StyledUserCard>
  );
};

export default UserCard;
